export const WHATSAPP_NUMBER = "+91 86999 49915";
export const PHONE_SECONDARY = "+91 97799 97673";
export const EMAIL = "admin@chatproz.com";
export const SOCIAL_LINKS = [
    { label: "LinkedIn", href: "https://www.linkedin.com/in/kuunalpruuthi/" },
    { label: "Instagram", href: "https://www.instagram.com/kuunalpruuthi/" },
    { label: "YouTube", href: "https://www.youtube.com/@kuunalpruuthi" },
];
export const WHATSAPP_LINK =
    "https://wa.me/918699949915?text=" +
    encodeURIComponent("Hi ChatProz! I'd like to talk about growth for my business.");

export const NAV_LINKS = [
    { label: "Services", href: "#services" },
    { label: "Who We Help", href: "#fit" },
    { label: "Impact", href: "#proof" },
    { label: "Founder", href: "#founder" },
    { label: "In News", href: "#press" },
    { label: "Process", href: "#process" },
];

export const TRUST_ITEMS = [
    "5K → 734K followers · Simrat Kathuria, Diet Xperts",
    "More than a decade in marketing, branding & business",
    "Govt-recognized by DC Ludhiana",
    "Founder, CNI Channel, Ludhiana's first online web channel",
];

export const CAPABILITIES = [
    {
        id: "01",
        name: "BUILD",
        tagline: "The foundation.",
        items: [
            "Websites & landing pages that convert",
            "Custom CRM–ERP built around your process",
            "Mobile apps your customers actually use",
        ],
    },
    {
        id: "02",
        name: "AUTOMATE",
        tagline: "The engine.",
        items: [
            "Custom chatbots that qualify leads 24/7",
            "Custom voice agents that never miss a call",
            "WhatsApp Business API, at scale",
        ],
    },
    {
        id: "03",
        name: "GROW",
        tagline: "The fuel.",
        items: [
            "Digital marketing, end to end",
            "Meta & Google ads",
            "Social media management",
            "Instagram & YouTube growth",
            "Brand positioning",
        ],
    },
];

export const INDUSTRY_FEATURES = [
    "Custom CRM–ERP wired to your sales floor",
    "WhatsApp Business API",
    "Chatbots & voice agents",
    "Lead-gen ads on Meta & Google",
    "Automated email + WhatsApp follow-up",
];

export const CREATOR_FEATURES = [
    "Social media management",
    "Instagram & YouTube growth",
    "Brand positioning",
    "Customizable Content Engine",
    "AI Avatar",
];

export const CREATOR_RESULTS = [
    {
        name: "Simrat Kathuria",
        tag: "Diet Xperts · Creator track",
        img: "/simrat-kathuria.jpg",
        stat: "5K → 734K",
        caption: "Real Instagram growth, done for her brand.",
    },
    {
        name: "Nazuuk Purri",
        tag: "Creator track",
        img: "/nazuk-puri.jpg",
        stat: "64.3K",
        caption: "Instagram followers, grown and counting.",
    },
    {
        name: "City Needs",
        tag: "Help Locally · Brand growth",
        img: "/city-needs.jpg",
        stat: "17.3K",
        caption: "Support in building an ecosystem through social media.",
    },
];

export const PRESS_ARTICLES = [
    {
        outlet: "The Tech Panda",
        logo: "/press/the-tech-panda.png",
        darkChip: true,
        title: "AI & Automation in Indian Digital Marketing: A Game-Changer for ROI",
        url: "https://thetechpanda.com/ai-automation-in-indian-digital-marketing-a-game-changer-for-roi/41785/",
    },
    {
        outlet: "DQ Channels",
        logo: "/press/dq-channels.png",
        title: "Rise of Digital Marketing in India: Consumer Behaviour Trends in 2025",
        url: "https://www.dqchannels.com/guest-gyan/rise-of-digital-marketing-in-india-consumer-behaviour-trends-in-2025-8959329",
    },
    {
        outlet: "IndianWeb2",
        logo: "/press/indianweb2.png",
        title: "Scaling Indian Startups: Growth Consulting Strategies for Digital Success",
        url: "https://www.indianweb2.com/2025/05/scaling-indian-startups-growth.html",
    },
    {
        outlet: "Express Computer",
        logo: "/press/express-computer.png",
        title: "How Digital Marketing Drives the Next Wave of E-Commerce",
        url: "https://www.expresscomputer.in/guest-blogs/how-digital-marketing-drives-the-next-wave-of-e-commerce/125933/",
    },
    {
        outlet: "Dailyhunt · Tycoon World",
        logo: "/press/dailyhunt.png",
        title: "Social Media Platforms: The Battle for India's Attention Span",
        url: "https://m.dailyhunt.in/news/india/english/tycoon+world-epaper-dh4c6a646b987d48f5b87f17d40865f089/social+media+platforms+the+battle+for+indias+attention+span-newsid-dh4c6a646b987d48f5b87f17d40865f089_2b1c2f70242611f0bbfe75aa5433ecbb",
    },
];

export const IMAGES = {
    industry: "/split-industry.jpg",
    creators: "/split-creators.jpg",
    abstract:
        "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGFpJTIwdGVjaG5vbG9neSUyMGJsdWUlMjBub2RlfGVufDB8fHx8MTc4ODE3NTE1MXww&ixlib=rb-4.1.0&q=85",
};

export const YOUTUBE_EMBED = "https://www.youtube.com/embed/z-tVAdSiuT0";

export const CHAT_GREETING =
    "Hi, I am the ChatProz assistant. I can answer questions and book a call with Kuunal. What are you working on?";

export const CHAT_STARTERS = [
    "Book a call with Kuunal",
    "What do you do for creators?",
    "Can you automate my WhatsApp enquiries?",
];
